<template>
  <div>
    <!-- Online Matching 弹框 -->
    <el-dialog
      title=""
      class="dialog_modal dc_match"
      :visible.sync="onlineMatchingVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onlineMatchingClose"
      width="1000px"
    >
      <div class="match-dialog-title">Online Matching</div>
      <div class="match-dialog-rematch">
        <span @click="openMatchingDialog">No matching data available</span>
      </div>

      <div class="searchCompany-condition">
        <div class="flex_center_start searchCompany-condition-row"
        >
          <!-- 国家 -->
          <div class="searchCompany-condition-item">
            <input
              type="text"
              v-model="cascInptCountry"
              v-show="showInptCountry"
              class="cas_input"
              :placeholder="$t('ListofResults.SelectCountry')"
              @input="inptCountrySearch"
            />
            <el-cascader
              ref="Country"
              v-click-outside="clickOutSide3"
              :placeholder="$t('ListofResults.SelectCountry')"
              :key="cascaderKey"
              v-model="countryCheckList"
              @change="menuCheck('country')"
              :options="countryList"
              :props="{ multiple: true }"
              collapse-tags
              popper-class="cas_loc_box search_cas_loc_box ticket_ccCascader"
            >
              <template slot-scope="{ data }">
                <el-tooltip
                  popper-class="dataservice-country-tooltip"
                  class="casca_lab"
                  effect="dark"
                  :disabled="data.label.length < 10"
                  :content="data.label"
                  placement="left"
                >
                  <span class="casca_lab">
                    <span ref="sty">{{ data.label }}</span>
                  </span>
                </el-tooltip>
                <span class="casca_count">{{ data.count | FilterNum }}</span>
              </template>
            </el-cascader>
          </div>
          <!-- 关键字 -->
          <div class="searchCompany-condition-item search_right">
            <el-input
              placeholder="Enter company name"
              v-model="searchName"
              @keydown.enter.native="EnterSearch()"
              >
              <i slot="prefix" class="el-input__icon el-icon-search"
              @click="EnterSearch"
              ></i>
            </el-input>
          </div>
          <el-button 
          type="primary" 
          class="dc-cleaning-btn reset"
          @click="clearAllReset">Clear All</el-button>
        </div>
        <div class="flex_center_start searchCompany-condition-row ">
          <!-- 行业 -->
          <div class="searchCompany-condition-item">
            <input
              type="text"
              v-model="cascInptIndustry"
              v-show="showInptIndustry"
              class="cas_input"
              :placeholder="$t('ListofResults.SelectIndustry')"
              @input="inptIndSearch"
            />
            <el-cascader
              ref="Industry"
              v-click-outside="clickOutSide4"
              clearable
              v-model="industryCheckList"
              :key="cascaderKey"
              :options="industryList"
              :props="optionsProps"
              @change="menuCheck('Industry')"
              :placeholder="$t('ListofResults.SelectIndustry')"
              popper-class="cas_loc_box search_cas_loc_box2 indystry"
            >
              <template slot-scope="{ data }">
                <el-tooltip
                  class=""
                  effect="dark"
                  :content="data.name"
                  popper-class="el-tooltip-postion"
                  placement="right"
                >
                  <span class="casca_lab casca_labtwo">{{ data.name }}</span>
                </el-tooltip>
              </template>
            </el-cascader>
          </div>
          <!-- company type -->
          <div class="searchCompany-condition-item">
            <el-select v-model="companyTypeCheckList" 
            placeholder="Select Company Type"
            multiple 
            :multiple-limit="1"
            @change="menuCheck('companyType')">
              <el-option
                v-for="item in companyTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                <div class="searchCompany-multiple-option flex_center_bettwen">
                  <div class="searchCompany-multiple-option-label line_1">{{item.name}}</div>
                  <div class="searchCompany-multiple-option-count">{{item.count | FilterNum}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!-- company size -->
          <div class="searchCompany-condition-item">
            <el-select v-model="companySizeCheckList" 
            placeholder="Select Company Size"
            multiple 
            :multiple-limit="1"
            @change="menuCheck('companySize')">
              <el-option
                v-for="item in companySizeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                <div class="searchCompany-multiple-option flex_center_bettwen">
                  <div class="searchCompany-multiple-option-label line_1">{{item.name}}</div>
                  <div class="searchCompany-multiple-option-count">{{item.count | FilterNum}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!-- company status -->
          <div class="searchCompany-condition-item">
            <el-select v-model="companyStatusCheckList" 
            placeholder="Select Company Status"
            multiple 
            :multiple-limit="1"
            @change="menuCheck('companyStatus')">
              <el-option
                v-for="item in companyStatusList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                <div class="searchCompany-multiple-option flex_center_bettwen">
                  <div class="searchCompany-multiple-option-label line_1">{{item.name}}</div>
                  <div class="searchCompany-multiple-option-count">{{item.count | FilterNum}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!-- Listed -->
          <div class="searchCompany-condition-item">
            <el-select v-model="listedCompanyCheckList" 
            placeholder="Select listed companies"
            multiple 
            :multiple-limit="1"
            @change="menuCheck('listedCompany')">
              <el-option
                v-for="item in listedCompanyList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                <div class="searchCompany-multiple-option flex_center_bettwen">
                  <div class="searchCompany-multiple-option-label line_1">{{item.name}}</div>
                  <div class="searchCompany-multiple-option-count">{{item.count | FilterNum}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
          <!-- years -->
          <div class="searchCompany-condition-item">
            <el-select v-model="timePeriodCheckList" 
            placeholder="Select company years in business"
            multiple 
            :multiple-limit="1"
            @change="menuCheck('timePeriod')">
              <el-option
                v-for="item in timePeriodList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                <div class="searchCompany-multiple-option flex_center_bettwen">
                  <div class="searchCompany-multiple-option-label line_1">{{item.name}}</div>
                  <div class="searchCompany-multiple-option-count">{{item.count | FilterNum}}</div>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="onlineMatch-dialog-content">
        <el-table
          v-loading="matchTableloding"
          ref="multipleMatchTable"
          class="match-table"
          :data="companyList"
          row-key="id"
          tooltip-effect="dark"
          style="width: 100%"
          @row-click="handleRowClick"
          @selection-change="handleSelectionOnlineMatch">
          <el-table-column width="55">
            <template #default="{ row }">
              <el-radio
                v-model="selectedId"
                :label="row.id"
                @click.native.stop 
              >&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="Co. Name"
            width="360"
            align="left"
            show-overflow-tooltip
            :resizable="false"
          >
            <template slot-scope="scope">
              <div class="line_1 flex_center_start match-companyname" style="width: 340px">
                <img :src="scope.row.flag"/>
                <div @click="toCompanyDetail(scope.row)"
                class="tbl_company line_1">
                  {{ scope.row.company_name_en }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Country"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
              {{ getCountry(scope.row.company_country) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="company_class_en"
            label="Type"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="status_en"
            label="Status"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div class="page_i_box dataService">
          <Page
            :totalFont="true"
            :total="page.total"
            :pageSize.sync="page.pageSize"
            :currentPage="page.pageNo"
            @onPageChange="onPageChangeList"
          ></Page>

          <div class="search_rsult_txt line_2">
            {{ page.pageNo }}-{{ page.pageSize }} of over
             <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results
          </div>
        </div>
      </div>
      <div class="dc-dialog-footer flex_center onlineMatching">
        <el-button 
        class="dc-cleaning-btn-cancel"
        @click="onlineMatchingClose">Cancel </el-button>
        <el-button 
        type="primary" 
        class="dc-cleaning-btn"
        :disabled="!selectedId"
        @click="onlineMatchingSubmit">Confirm</el-button>
      </div>
    </el-dialog>
    <!-- Offline Matching 弹框 -->
    <el-dialog
      title=""
      class="dialog_modal dc_match "
      :visible.sync="offlineMatchingVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
    >
      <div class="match-dialog-title">Offline Matching</div>
      
      <div class="offlineMatch-dialog-content">
        <div class="offlineMatch-dialog-tips">
          Fill in the following information and send it to customer service, and we will match your data as soon as possible
        </div>
        <el-row :gutter="20" class="offlineMatch-dialog-form">
          <el-form 
          ref="offlineMatchForm" 
          :model="offlineMatchForm" 
          label-width="160px"
          label-position="left">
            <el-col :span="12">
              <el-form-item label="Co. Name:">
                <el-input v-model="offlineMatchForm.companyName"
                placeholder="Enter company Name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Co. ID:">
                <el-input v-model="offlineMatchForm.companyId"
                placeholder="Enter company ID"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Country:">
                <el-select v-model="offlineMatchForm.country" placeholder="Enter Country">
                  <el-option 
                  :label="item.nameEn" :value="item.code"
                  v-for="item in allCountry"
                  :key="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="State/Province:">
                <el-select v-model="offlineMatchForm.province" placeholder="Select State/Province">
                  <el-option 
                  :label="item.nameEn" :value="item.code"
                  v-for="item in allCountry"
                  :key="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="Address:">
                <el-input v-model="offlineMatchForm.address"
                placeholder="Enter Address"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Other Information:">
                <el-input v-model="offlineMatchForm.otherInformation"
                type="textarea"
                :autosize="{ minRows: 4,}"
                placeholder="Enter Information"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          
        </el-row>
      </div>
      <div class="dc-dialog-footer flex_center">
        <el-button 
        class="dc-cleaning-btn-cancel"
        @click="offlineMatchingCancel">Cancel </el-button>
        <el-button 
        type="primary" 
        class="dc-cleaning-btn"
        @click="offlineMatchingSubmit">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import Page from '@/components/page/index.vue';
import { searchCompany } from "@/api/searchApi.js";
import { getoptions } from "@/api/companyApi";

import { matchUploadDataCleaning, insertOfflineMatchingEntity } from "@/api/dataServicesApi";
export default {
  mixins: [mixins1],
  components: {
    Page
  },
  props: {
    currentRow: { type: Object, default: () => {} },
    dialogVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      onlineMatchingVisible: false,
      countryCode1: "",
      countryCode: "",
      countryName: "", //选中国家
      countryImg: "", //选中国家的国旗
      tabActiveName: "", //选择的区域
      //国家分类
      tabCountryList: [],
      searchName: "",
      companyList: [],
      multipleSelection: [],
      page: {
        pageSize: 5,
        pageNo: 1,
        total: 0
      },
      matchTableloding: false,
      offlineMatchingVisible: false,
      offlineMatchForm: {
        companyName: '',
        companyId: '',
        country: '',
        // province: '',
        address: '',
        otherInformation: ''
      },
      matchCurrentRow: {},
      // 索引条件
      Leftloadig: false,
      selectedId: null,      // 用于绑定 radio 的值（必须是基础类型，如 id）
      selectedRow: null,      // 存储完整的选中行对象
      
      companyTypeList: [],
      companySizeList: [],
      companyStatusList: [],
      listedCompanyList: [],
      timePeriodList: [],
      // 国家
      countryList: [],
      countryPreList: [],
      cascInptCountry: "",
      showInptCountry: true,
      countryCheckList: [],
      // 行业
      industryList: [],
      industryPreList: [],
      cascInptIndustry: "",
      showInptIndustry: true,
      industryCheckList: [],
      cascaderKey: 0,
      optionsProps: {
        label: "name", //名称展示
        value: "value", //值展示
        expandTrigger: "click", //次级菜单的展开方式
      },
      companyTypeList: [],
      companyTypeList1: [],
      companyTypeCheckList: [],
      companyTypeTag: [],
      companyTypeCheck: "",

      companySizeList: [],
      companySizeCheckList: [],
      companySizeTag: [],
      companySizeCheck: "",

      companyStatusList: [],
      companyStatusCheckList: [],
      companyStatusTag: [],
      companyStatusCheck: "",

      listedCompanyList: [],
      listedCompanyCheckList: [],
      listedCompanyTag: [],
      listedCompanyCheck: "",

      timePeriodList: [],
      timePeriodCheckList: [],
      timeTag: [],
      timePeriodCheck: "",
      province: [],
      city: [],
      keywords: "",
      cascaderKey: 0,
      Leftloadig: false,
      searchName: "",
      isShowTooltip: false,
      checkList: [],
      labelCodeName: "",

    };
  },
  watch: {
    countryList(val) {
      this.cascaderKey++;
    },
    industryList(val) {
      this.cascaderKey++;
    },
    dialogVisible: {
      handler(newVal) {
        console.log('弹框', newVal);
        this.onlineMatchingVisible = newVal;
        if(!newVal){
          this.clearAllTags();
          
        } else{
          this.countryCheck = this.currentRow.companyCountry || '';
          this.searchName = this.currentRow.companyName || '';
          this.searchCompanyByName();
        }
        
      },
      immediate: true
    },
    // 监听 selectedId 变化，同步更新 selectedRow
    selectedId(newId) {
      if (newId === null) {
        this.selectedRow = null;
      } else {
        // 从 tableData 中找到完整对象
        this.selectedRow = this.companyList.find(row => row.id === newId) || null;
      }
    },
  },
  updated() {
    this.$nextTick(function () {
      this.formatCC();
    });

    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  created() {
    this.getAllCountry();
  },
  computed: {
    allCountry(){
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      return newscountry
    },
  },
  methods: {
    handleRowClick(row) {
      console.log(row);
      this.selectedId = row.id; // 触发 watcher 更新 selectedRow
    },
    onlineMatchingClose(){
      this.$emit('closeDialogOnlineMatch');
      this.clearAllTags();
    },
    async onlineMatchingSubmit(){
      let params = {
        cleaningId: this.currentRow.id,
        indexResultJSON: JSON.stringify(this.selectedRow),
      }
      console.log('参数', params);
      await matchUploadDataCleaning(params).then((res) => {
        console.log('online match',JSON.parse(JSON.stringify(res)));
        if (res.code == 200) {
          this.$message.success(res.msg);
          // 关掉弹框，刷新二级列表
          this.$emit('closeDialogOnlineMatch', 'refresh');
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    offlineMatchingCancel(){
      this.offlineMatchingVisible = false;
    },
    async offlineMatchingSubmit(){
      // this.offlineMatchingVisible = false;
      let {companyName, companyId, country, address, otherInformation}= this.offlineMatchForm;
      let params = {
        itemId: this.currentRow.id,
        companyName,
        companyId,
        country,
        address,
        otherInformation
      }
      console.log('参数', params);
      await insertOfflineMatchingEntity(params).then((res) => {
        console.log('offline match',JSON.parse(JSON.stringify(res)));
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$refs.offlineMatchForm.resetFields();
          this.offlineMatchingVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    openMatchingDialog(){
      this.offlineMatchingVisible = true;
    },
    // 点击跳转
    toCompanyDetail(row) {
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let companyCountryEn = "";
      newscountry.map((item) => {
        if (item.countryCode == row.company_country) {
          companyCountryEn = item.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaa_id +
          "/background/snapshot?id3a=" +
          row.aaa_id +
          "&companyCountry=" +
          row.company_country +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=2",
      });

      window.open(routeData.href, "_blank");
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page
      this.searchCompanyByName();

    },
    EnterSearch() {
      this.page.pageNo = 1;
      this.page.total = 0;
      if (this.$refs.multipleMatchTable) {
        this.$refs.multipleMatchTable.clearSelection();
      }
      this.companyList = [];

      this.searchCompanyByName();
    },
    //搜索公司
    async searchCompanyByName() {
      if(this.searchName && this.searchName.trim() == ''){
        this.$message.error('Enter company name');
        this.searchName = '';
        return;
      }
      this.matchTableloding = true;
      let params = {
        company_country: this.countryCheck,
        company_name: this.searchName,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        isic_code: this.industryCheck,
        company_class_code: this.companyTypeCheck,
        searchType: 2,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
      };
      let res = await searchCompany(params);
      let companyList = [];
      if (res.code == 200) {
        this.matchTableloding = false;
        this.page.total = res.data.total;
        let list = (companyList = res.data.rows);

        //查找本地图片
        list = list.map((item, index) => {
          let countryImg = this.getCountryImgUrl(item.company_country);
          if (countryImg) {
            let flag = require("../../../../static" + countryImg);

            companyList[index].flag = flag;
            this.refresh++;
          }
        });
        this.companyList = companyList;
        console.log(JSON.parse(JSON.stringify(this.companyList)));
      } else {
        this.matchTableloding = false;
        if (res.code == "1002") {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        } else {
          this.companyList = [];
        }
      };
      this.getConditions();
    },
    //获取筛选条件
    async getConditions() {
      this.Leftloadig = true;
      const params = {
        // aaaids: this.labelCode.length == 0 ? "" : labelCodeArr,
        company_country: this.countryCheck,
        company_name: this.searchName,
        // province_en: this.province,
        // companyLabelV2: this.$route.query.CompanyDetail,
        // city_en: this.city,
        industry_en: this.industryCheck,
        company_class_code: this.companyTypeCheck,
        searchType: 2,
        scale_code: this.companySizeCheck,
        reg_status: this.companyStatusCheck,
        listing_status_code: this.listedCompanyCheck,
        years: this.timePeriodCheck,
      };
      await getoptions(params).then((res) => {
        if (res && res.code) {
          this.Leftloadig = false;
          this.countryList = res.data.geographicalLocation;
          this.industryList = res.data.industry;
          this.industryPreList = res.data.industry;

          this.companyTypeList = res.data.companyTypeList;

          this.companySizeList = res.data.companySizeList;
          this.companyStatusList = res.data.regStatus;
          this.listedCompanyList = res.data.listingStatusList;
          this.timePeriodList = res.data.yearsOfEstablishment;

          let list = this.countryList;
          if (list.length > 0) {
            list.map((item, index) => {
              item.label = item.companyCountry.name;
              item.value = item.companyCountry.value;
              item.count = item.companyCountry.count;
              if (item.companyProvince) {
                item.children = item.companyProvince;
                item.children.map((it) => {
                  it.label = it.name;
                });
              }
            });
          }
          this.countryPreList = list;
        } else {
          this.Leftloadig = false;
        }
      });
    },
    //菜单checkbox选择
    menuCheck(val) {
      if (val === "country") {
        const checkedNodes = this.$refs.Country.getCheckedNodes();
        const allNodes = this.$refs.Country.getCheckedNodes(true);
        const isAllSelected = checkedNodes.length === allNodes.length;
        let arrCountry = [];
        let arrProv = [];
        let arrCountryTag = [];
        let arrCountrycheck = [];
        this.countryCheckList.forEach((item) => {
          if (isAllSelected) {
            if (item.length == 1) {
              if (!arrCountry.includes(item[0])) {
                this.countryList.forEach((ite) => {
                  if (ite.value == item[0]) {
                    arrCountryTag.push(ite.label); //展示
                  }
                });

                arrCountry.push(item[0]); //传值
              }
            } else {
              arrProv.push(item[1]);
            }
          } else {
            if (!arrCountry.includes(item[0])) {
              this.countryList.forEach((ite) => {
                if (ite.value == item[0]) {
                  arrCountryTag.push(ite.label); //展示
                }
              });

              arrCountry.push(item[0]); //传值
            }
          }

          if (!arrCountrycheck.includes(item[0])) {
            arrCountrycheck.push(item[0]); //传值
          }
        });
        console.log('选中的国家', this.countryCheckList);
        this.countryTag = arrCountryTag;
        this.arrProvTag = arrProv;

        this.countryCheck = arrCountrycheck.join("@@");
        this.province = arrProv.join("@@");

        //显示隐藏国家级联选择器的输入框
        if (this.countryTag.length > 0 || this.arrProvTag.length > 0) {
          this.showInptCountry = false;
          this.cascInptCountry = "";
        } else {
          this.showInptCountry = true;
        }
      } else {
        if (val === "Industry") {
          let arr = [];
          this.industryCheckList.forEach((item) => {
            this.industryList.forEach((it) => {
              if (it.value == item) {
                arr.push(it);
              }
            });
          });
          this.industryTag = arr;
          this.industryCheck = this.industryCheckList[1];
          //显示隐藏行业级联选择器的输入框
          if (this.industryCheckList.length > 0) {
            this.showInptIndustry = false;
            this.cascInptIndustry = "";
          } else {
            this.showInptIndustry = true;
          }
        }
        let arr = [];

        this.companyTypeCheckList.forEach((item) => {
          this.companyTypeList.forEach((it) => {
            if (it.value == item) {
              arr.push(it);
            }
          });
        });
        this.companyTypeTag = arr;
        let arrlist = [];
        arr.map((item) => {
          arrlist.push(item.value);
        });

        this.companyTypeCheck = arrlist.join("@@");
        let arr1 = [];
        this.companySizeCheckList.forEach((item) => {
          this.companySizeList.forEach((it) => {
            if (it.value == item) {
              arr1.push(it);
            }
          });
        });
        let arrlist1 = [];
        arr1.map((item) => {
          arrlist1.push(item.value);
        });
        this.companySizeTag = arr1;
        this.companySizeCheck = arrlist1.join("@@");
        let arr2 = [];
        this.listedCompanyCheckList.forEach((item) => {
          this.listedCompanyList.forEach((it) => {
            if (it.value == item) {
              arr2.push(it);
            }
          });
        });
        let arrlist2 = [];
        arr2.map((item) => {
          arrlist2.push(item.value);
        });
        this.listedCompanyTag = arr2;
        this.listedCompanyCheck = arrlist2.join("@@");
        let arr3 = [];
        this.companyStatusCheckList.forEach((item) => {
          this.companyStatusList.forEach((it) => {
            if (it.value == item) {
              arr3.push(it);
            }
          });
        });
        let arrlist3 = [];
        arr3.map((item) => {
          arrlist3.push(item.value);
        });
        this.companyStatusTag = arr3;
        this.companyStatusCheck = arrlist3.join("@@");
        let arr4 = [];
        this.timePeriodCheckList.forEach((item) => {
          this.timePeriodList.forEach((it) => {
            if (it.value == item) {
              arr4.push(it);
            }
          });
        });
        let arrlist4 = [];
        arr4.map((item) => {
          arrlist4.push(item.value);
        });
        this.timeTag = arr4;
        this.timePeriodCheck = arrlist4.join("@@");
        this.companyList = [];
        this.page.pageNo = 1;
        this.searchCompanyByName();
      }

      // this.$store.dispatch("app/setcollectList", []);
      // this.$store.dispatch("app/setchangeList", this.compareList);
      // this.handleSelectionChange([]);
      // this.ChildhandleSelectionChange([]);
    },
    // 国家筛选新增添加删除
    formatCC() {
      let htmladd = document.createElement("bottom");
      let htmladd2 = document.createElement("bottom2");

      htmladd.innerHTML = "Confirm";
      htmladd.className = "htmladd";
      htmladd2.innerHTML = "Delete";
      htmladd2.className = "htmladd2";
      htmladd.style.cssText =
        "cursor: pointer;position: absolute;bottom: -35px;height: 35px;line-height:35px;width:50%;background:#fff;text-align: center;color:#606266;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);";
      htmladd2.style.cssText =
        "cursor: pointer;position: absolute;bottom: -35px;right: 0;height: 35px;line-height:35px;width:50%;background:#fff;text-align: center;color:#606266;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);";
      let that = this;
      var el_l = document.querySelectorAll(
        ".el-popper.el-cascader__dropdown.ticket_ccCascader",
      );
      if (el_l.length > 0 && el_l.length == 1) {
        var el = el_l[0];

        if (!el.querySelector(".htmladd")) {
          el.appendChild(htmladd);
          var bo = el.querySelectorAll(".htmladd")[0];
          bo.onclick = function () {
            that.$refs.Country.dropDownVisible = false;
            that.getConditions();
            that.page.pageNo = 1;
            that.companyList = [];
            that.searchCompanyByName();
          };
        }

        var el1 = el_l[0];
        if (!el1.querySelector(".htmladd2")) {
          el1.appendChild(htmladd2);
          var bo1 = el1.querySelectorAll(".htmladd2")[0];
          bo1.onclick = function () {
            that.countryCheckList = [];
            that.countryTag = [];
            that.province = "";
            that.arrProvTag = [];
            that.countryCheck = "";
            that.$refs.Country.dropDownVisible = false;
            that.showInptCountry = true;
            that.companyList = [];
            that.page.pageNo = 1;
            that.getConditions();
            that.searchCompanyByName();
          };
        }
      }
    },
    clearAllReset(){
      this.clearAllTags();
      this.searchCompanyByName();
    },
    //清除所有标签
    clearAllTags() {
      // this.searchName = '';
      this.countryCheckList = [];
      this.industryCheckList = [];
      this.companyTypeCheckList = [];
      this.companySizeCheckList = [];
      this.companyStatusCheckList = [];
      this.listedCompanyCheckList = [];
      this.timePeriodCheckList = [];
      this.page.pageNo = 1;
      this.industryCheck = "";
      this.companyTypeCheck = "";
      this.companySizeCheck = "";
      this.companyStatusCheck = "";
      this.listedCompanyCheck = "";
      this.timePeriodCheck = "";
      this.showInptCountry = true;
      this.province = "";
      this.company_country = "";
      this.countryCheck = "";
      this.companyList = [];
      this.selectedId = null;
      // this.searchCompanyByName();
    },
    //国家级联搜索不区分大小写
    inptCountrySearch() {
      this.$nextTick(() => {
        this.$refs.Country.dropDownVisible = true;
      });
      let queryString = this.cascInptCountry;
      var countryList = this.countryPreList;
      var results = queryString
        ? countryList.filter(this.createFilter(queryString))
        : countryList;
      this.countryList = results;
    },
    // 过滤数据
    createFilter(queryString) {
      return (countryList) => {
        return (
          countryList.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    clickOutSide3() {
      if (this.$refs.Country) {
        this.$refs.Country.dropDownVisible = false;
      }
    },
    //行业级联搜索不区分大小写
    inptIndSearch() {
      this.$nextTick(() => {
        this.$refs.Industry.dropDownVisible = true;
      });
      let queryString = this.cascInptIndustry;
      var industryList = this.industryPreList;

      var results = queryString
        ? industryList.filter(this.createFilterInd(queryString))
        : industryList;
      this.industryList = results;
    },
    clickOutSide4() {
      if (this.$refs.Industry) {
        this.$refs.Industry.dropDownVisible = false;
      }
    },
    handleSelectionOnlineMatch(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    async getAllCountry() {
      let countryCode = (this.countryCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "");
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = require("../../../../static/imagev2/zanwutupian.png");
            } else {
              countryImg = it.urlBanner.split("./../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../../static" + countryImg);
            } catch (error) {
              countryImg = "../../../../static/imagev2/zanwutupian.png";
              // 提供一个默认值或者其他处理方式
              flag = require("../../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      }
    },
    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },
    //下拉选择国家
    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
      // 如果有关键字，直接搜索
      if((!!this.searchName) && (this.searchName.trim() !== '')){
        this.EnterSearch();
      }
      
    },
    
  },
};
</script>
<style scoped>
/* match弹框 */
.dc_match /deep/ .el-dialog__body{
  padding: 20px;
}
.dc_match /deep/  .el-dialog{
  max-height: none;
}
.match-dialog-title{
  font-size: 26px;
  color: #1A2332;
  line-height: 27px;
  text-align: center;
  font-family: 'Arial Bold';
}
.match-dialog-rematch{
  text-align: right;
  font-size: 20px;
  color: #1290C9;
  line-height: 26px;
  text-decoration: underline;
  margin-top: 10px;
}
.match-dialog-rematch span{
  cursor: pointer;
}
.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.match-table{
  border-radius: 8px;
  border: 1px solid #CCCCCC;
}
.match-table /deep/ .el-table__empty-block{
  background-image: url("../../../assets/images/empty.png") !important;
  margin: 50px 0 !important;
  min-height: 180px !important;
  background-size: contain !important;
}
.match-table /deep/ tr:last-of-type td{
  border-bottom: 0;
}
.match-table /deep/ th:first-child > .cell {
  padding-left: 14px;
}
.match-table /deep/ tr:hover>td.el-table__cell {
  background: #FAF1EC;
}
.match-table /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #B98B73;
  background: #fff;
}
.match-table /deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #B98B73;
}
.match-companyname .tbl_company{
  color: #1A2332;
}
.match-companyname .tbl_company:hover{
  color: #b98b73;
}
.match-companyname img{
  width:32px;
  height:auto;
  margin-right: 5px;
  box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 20%);
}
.offlineMatch-dialog-content{
  padding: 10px;
}
.offlineMatch-dialog-tips{
  font-size: 20px;
  color: #1A2332;
  line-height: 30px;
}
.offlineMatch-dialog-form{
  width: 100%;
  background: #F5F5F5;
  border-radius: 6px;
  padding: 20px;
  margin: 10px 0 20px;
  font-size: 18px;
  color: #1A2332;
}
.offlineMatch-dialog-form /deep/ .el-form-item__label{
  line-height: 50px;
  font-size: 16px;
  color: #1A2332;
}
.offlineMatch-dialog-form /deep/ .el-form-item__content .el-select{
  width: 100%;
}
.searchCompany-condition /deep/ .el-input__inner::placeholder,
.cas_input::placeholder,
.offlineMatch-dialog-form /deep/ .el-input__inner::placeholder,
.offlineMatch-dialog-form /deep/ .el-textarea__inner::placeholder{
  font-size: 16px !important;
  color: #999999 !important;
}
.offlineMatch-dialog-form /deep/ .el-textarea__inner{
  border-color: #DCDFE6;
}
.dc-dialog-footer{
  padding: 0 15px;
  margin-bottom: 14px;
  /* gap: 0 10px; */
}
.dc-dialog-footer.onlineMatching{
  margin-top: 18px;
}
.dc-cleaning-btn{
  width: 210px;
  height: 60px;
  background: #B98B73;
  border-radius: 10px;
  font-size: 20px;
  color: #FFFFFF;
}
.dc-cleaning-btn.reset{
  width: 110px;
  height: 50px;
  font-size: 16px;
  margin: 0 5px 5px 0;
}
.dc-cleaning-btn-cancel{
  width: 210px;
  height: 60px;
  border-radius: 10px;
  border: 1px solid #B98B73;
  font-size: 20px;
  color: #B98B73;
}
.searchCompany-condition{
  padding: 10px 5px 5px;
  background-color: #F0F0F0;
  margin-bottom: 10px;
  border-radius: 10px;
}
.searchCompany-condition-row{
  flex-wrap: wrap;
  /* gap: 5px 10px; */
}
.searchCompany-condition-item{
  /* width: 32%; */
  position: relative;
  flex: 0 0 calc(33.333% - 10px); /* 每项占 1/3 宽度，减去间距 */
  margin: 0 5px 5px;
  box-sizing: border-box;          /* 确保 padding/border 包含在宽高中 */
}
.search_right{
  /* width: 65%; */
  flex: 1;
}
.search_right /deep/ .el-input .el-input__prefix{
  left: 10px;
  cursor: pointer;
}
.search_right /deep/ .el-input .el-input__inner{
  padding-left: 40px;
}
.search_right /deep/ .el-input .el-icon-search:before{
  font-size: 22px;
  color: #8497AB;
}
.searchCompany-condition-item .el-select{
  width: 100%;
}
.searchCompany-condition-item .cas_input {
  position: absolute;
  z-index: 1;
  height: 34px;
  left: 8px;
  top: 8px;
  font-size: 16px;
  background-color: #fff;
  border: none;
  width: calc(100% - 40px);
}
.searchCompany-condition-item .el-cascader{
  width: 100%;
}
.searchCompany-condition-item .el-cascader /deep/ .el-input .el-icon-arrow-down {
  font-size: 20px;
  color: #1A2332;
}
.searchCompany-multiple-option{
  gap: 0 20px;
}
.searchCompany-multiple-option-label{
  width: 70%;
  flex-shrink: 0;
}
.searchCompany-multiple-option-count{
  width: 30%;
  flex-shrink: 0;
}
@media (max-width: 1920px) {
  /* .dc_match /deep/  .el-dialog{
    width: 750px !important;
  } */
  
}
@media (max-width: 1440px) {
  /* .dc_match /deep/  .el-dialog{
    width: 670px !important;
  } */
}
</style>
